import React, {useEffect} from "react";
import {injectIntl} from "react-intl";

const TranslateGoo = ({langOriginal, languages, tag, intl}) => {
  const langToString = (lang) => {
    return lang.reduce((all, one) => `${all},${one}`, "");
  }

  const langToArray = (lang) => {
    const data = [];

    lang.forEach(one => data.push({
      value: one,
      label: intl.formatMessage({ id: `GT.LANG.${one.toUpperCase()}` })
    }));

    return data;
  }

  const googleTranslateElementInit = async () => {
    window.google.translate.TranslateElement({
      pageLanguage: langOriginal,
      includedLanguages: langToString(languages),
      autoDisplay: false,
      layout: window.google.translate.TranslateElement.FloatPosition.BOTTOM_CENTER
    }, tag);

    const initCustomSelect = () => {
      const selectLangOptions = document.querySelectorAll('.goog-te-combo > option');
      selectLangOptions.forEach( lang => lang.remove() );

      const selectLang = document.querySelector('.goog-te-combo');

      let selectOptLang = document.createElement('option');
      selectOptLang.value = '';
      selectOptLang.innerHTML = intl.formatMessage({ id: `GT.LANG.SELECT` });
      selectLang.appendChild(selectOptLang);

      langToArray(languages).forEach(lang => {
        selectOptLang = document.createElement('option');
        selectOptLang.value = lang.value;
        selectOptLang.innerHTML = lang.label;
        selectLang.appendChild(selectOptLang);
      })
    }

    setInterval(async () => {
      if(document.querySelector(".goog-te-combo > option:nth-child(2)")?.value === 'bg')
        initCustomSelect();
    }, 1000)
  }

  useEffect(() => {
    const addDiv = document.createElement('div');
    addDiv.innerHTML = `
        <style>
            body>.skiptranslate, 
            #google_translate_element, 
            .goog-te-banner-frame.skiptranslate, 
            .goog-te-gadget>span,
            #goog-gt-tt {
                display: none !important;
            }
            .goog-te-gadget{font-size: 0px;}
            #${tag} {
                display: flex;
            }
            #${tag} > .skiptranslate {
                padding: 0 10px 0 10px;
                z-index: 1;
                width: 100%;
            }
            #${tag} > .skiptranslate select {
              display: block;
              width: 100%;
              height: calc(1.5em + 1.3rem + 2px);
              padding: 0.65rem 1rem;
              font-size: 1rem;
              font-weight: 400;
              line-height: 1.5;
              color: #3f4254;
              background-color: #ffffffdb;
              background-clip: padding-box;
              border: 1px solid #e4e6ef;
              border-radius: 0.42rem;
              box-shadow: none;
              transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            }
        </style>
    `;
    document.body.appendChild(addDiv);

    const addScript = document.createElement('script');
    addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, [])

  return (
    <div id={tag}/>
  );
};

export default injectIntl(TranslateGoo);
